setTimeout(()=>{
    jQuery('#input_1_1').prop('type','date');
    jQuery('#input_1_2').prop('type','date');
},3000);